<template>
    <modal
        dismissable
        :show="show"
        :container-classes="$style.termsModal"
        body-classes="p-0"
        :modal-classes="$style.termsModalDialog"
        @update:show="$emit('update:show', $event)"
    >
        <card
            class="card-form"
            :header-classes="$style.header"
            :body-classes="$style.cardBody"
        >
            <template slot="header">
                <h2 class="modal-title">Terms and Conditions</h2>
                <button
                    type="button"
                    class="close"
                    aria-label="Close"
                    @click="$emit('update:show', false)"
                >
                    <i class="tim-icons icon-simple-remove" />
                </button>
            </template>
            <div :class="$style.body">
                <el-divider />
                <h3>
                    Furniture receiving and delivery rates effective: 01-01-24
                </h3>
                <el-divider content-position="left">Receiving Rates</el-divider>
                <p><strong>Receiving</strong></p>
                <p>
                    Inspect for freight packaging damage only and take pictures,
                    (the item will not be opened unless there is box damage) -
                    $25.00 per item, this rate applies to items set up for
                    delivery, see accessorial charges for items set up for will
                    call.
                </p>
                <p><strong>Inspection</strong></p>
                <p>
                    Open and inspect each item for freight damage and take
                    pictures- $30.00 per item. Small items where inspection
                    charges would exceed the value of the item or where
                    inspection would be cost prohibitive can be removed from the
                    inspection upon request.
                </p>
                <p>
                    You may opt for receiving only or receiving and inspection.
                </p>
                <p>
                    We will need a minimum of 48 hours to process all inbound
                    furniture: Receiving, inspection, put away, data entry and
                    pictures. Will call pick up requests will need to be placed
                    48 hours in advance, if items have been here for an extended
                    length of time it may take us longer to get the items ready
                    for you.
                </p>
                <p><strong>Fed Ex and UPS</strong></p>
                <p>
                    Items shipped via Fed Ex and or UPS sometimes will contain
                    items where the cost to open and inspect the item will
                    exceed the value of the item. Please let us know in these
                    cases if you would prefer that we do not open and inspect
                    the items. Please note some projects are collected here for
                    several months so if we do not open the items and they are
                    damaged, the time for you to file a claim may expire. All
                    items sent to us will need to be clearly marked with the
                    company name, job name and a po number if available. Items
                    that come to us unmarked and that are unidentifiable will
                    incur a $35.00 research fee. We will be unable to look for
                    items that were sent to us without the freight bill number
                    and or a tracking number, we can't be responsible for the
                    accuracy of UPS or FED Ex packages, they do not have a BOL
                    or packing list detailing what they delivered, we will do
                    our best to account for all packages but they frequently
                    deliver our packages to other addresses, in such cases a
                    claim will need to be filed with the sender/manufacturer
                    formissing items, Delivery by Design will be unable to
                    accept claims for UPS, FED EX, DHL or other shipments that
                    do not have a signed BOL.
                </p>
                <p><strong>Delivery Charges</strong></p>
                <p>
                    Deliveries will be billed per the attached Base Rate Zip
                    Code sheet plus $15.00 per item on the delivery to account
                    for space on the truck in addition to applicable receiving
                    fees. The base rate includes 30 minutes on site for 2 men to
                    place the items, beyond 30 minutes will be charged hourly at
                    $72.50 per man hour billed in 15 minutes increments. Large
                    projects or deliveries with heavy items may require more
                    men.
                </p>
                <el-divider content-position="left"
                    >Delivery Cancellations</el-divider
                >
                <p>
                    All cancellations must be made at least 48 hours prior to
                    delivery or will be subject to a cancellation fee up to 100%
                    of the delivery charge.
                </p>
                <el-divider content-position="left"
                    >Accessorial Charges</el-divider
                >
                <div :class="$style.dottedListContainer">
                    <div :class="$style.dottedList">
                        <p :class="$style.dottedItem">
                            <span
                                >Assembly of flat packed items at
                                warehouse</span
                            >
                            <span>$62.50/HR</span>
                        </p>
                        <p :class="$style.dottedItem">
                            <span
                                >Labor for additional services while on
                                site</span
                            >
                            <span>$145.00/HR for a two man crew</span>
                        </p>
                        <p :class="$style.dottedItem">
                            <span>Will call fee</span>
                            <span
                                >$75.00 minimum or applicable receiving
                                fees</span
                            >
                        </p>
                        <p :class="$style.dottedItem">
                            <span>Storage charges after first 7 days</span>
                            <span
                                >$1.30 per cubic foot per month ($35 monthly
                                minimum)</span
                            >
                        </p>
                        <p :class="$style.dottedItem">
                            <span
                                >No fits or refusals due to no fault of
                                DBD</span
                            >
                            <span>Full charge</span>
                        </p>
                        <p :class="$style.dottedItem">
                            <span>Not at home due to no fault of DBD</span>
                            <span>Full charge</span>
                        </p>
                        <p :class="$style.dottedItem">
                            <span>Extra men for heavy deliveries</span>
                            <span>$72.50/man hour (includes travel)</span>
                        </p>
                        <p :class="$style.dottedItem">
                            <span>Pick ups</span>
                            <span>$145.00 per hour (two man crew)</span>
                        </p>
                        <p :class="$style.dottedItem">
                            <span>COD shipments paid by DBD</span>
                            <span>15% of freight bill</span>
                        </p>
                        <p :class="$style.dottedItem">
                            <span>In house repair services</span>
                            <span>$95.00 per hour</span>
                        </p>
                        <p :class="$style.dottedItem">
                            <span>On site repair services</span>
                            <span>$120.00 per hour</span>
                        </p>
                        <p :class="$style.dottedItem">
                            <span>Packaging and crating</span>
                            <span>Per quote</span>
                        </p>
                        <p :class="$style.dottedItem">
                            <span>Labor Rates</span>
                            <span
                                >$145.00 per hour (truck and two man crew)</span
                            >
                        </p>
                        <p :class="$style.dottedItem">
                            <span
                                >Transfer fee (furniture picked up by a
                                competitor)</span
                            >
                            <span>$75.00 added to will call fee.</span>
                        </p>
                        <p :class="$style.dottedItem">
                            <span>Fuel charge</span>
                            <span>10% of the base delivery charge.</span>
                        </p>
                    </div>
                </div>
                <el-divider content-position="left">Freight Claims</el-divider>
                <p>
                    Claims will be filed by the designer or design firm,
                    Delivery by Design will provide the signed BOL and all
                    pictures needed. Storage charges will apply after 14 days
                    while a claim is being processed. If the manufacturer or
                    freight company denies the claim, all receiving, inspection
                    and storage charges will still apply.If the manufacturer or
                    freight company prefers to replace the item, all charges
                    will apply to both the replacement and the original
                    items(s). You may elect to use our in house repair service
                    or a third party of your choosing. Delivery by Design
                    assumes no responsibility for the quality of repairs by a
                    third party. Delivery by Design assumes no responsibility if
                    attempted repair cannot be completed to the satisfaction of
                    the customer due to faulty, substandard or poor-quality
                    materials or finishes used by the manufacturer. Some
                    finishes cannot be duplicated and must be returned to the
                    manufacturer for repair or replacement. Delivery by Design
                    assumes no responsibility for proprietary finishes that
                    cannot be duplicated or matched for repair. Delivery by
                    Design may attempt such repairs and if unable to match, such
                    pieces will need to be replaced or repaired by the
                    manufacturer without chargeback to Delivery by Design.
                </p>
                <el-divider content-position="left">Returned Goods</el-divider>
                <p>
                    In cases where items must be returned to the manufacturer
                    for repair, replacement or due to duplicate ordersor
                    incorrect item shipped, we will charge $62.50 per man hour
                    plus materials to package the items for shipping, normal
                    receiving charges will apply and will be billed to the
                    client. It is the responsibility of the client to obtain an
                    RGA (return goods authorization) from the manufacture and
                    supply Delivery by Design with such.
                </p>
                <el-divider content-position="left">Insurance</el-divider>
                <p>
                    Insurance coverage may be obtained from the
                    Designers/Showrooms present insurance carrier in the form of
                    a rider. If the Designer/Showroom does not obtain such
                    coverage, we offer the following Storage and Delivery
                    Valuation options for damage directly caused by Delivery by
                    Design but does not cover any loss or damage due to Acts of
                    God, high winds, earthquakes, tornadoes, hurricanes, riots,
                    strikes, civil commotions, etc, Delivery by Design is fully
                    insured as are your goods under our general liability policy
                    for such occurrences. Delivery by Design will have the
                    option of repairing or replacing the damaged item(s)
                    whichever is less under either option. See next section
                    under Delivery and Storage Valuation.
                </p>
                <el-divider content-position="left"
                    >Delivery and Storage Valuation</el-divider
                >
                <p><strong>Option 1</strong></p>
                <p>
                    Your items are automatically covered by the minimum
                    liability coverage of $0.60 per pound per item for lost or
                    damaged items and is required by state law. This valuation
                    coverage protects you from damage or loss directly caused by
                    Delivery by Design while in storage or during the delivery.
                    By selecting this option, you agree that Delivery by Design
                    will not be responsible for any liability in excess of $0.60
                    per pound per article or the actual value of the item(s),
                    whichever is less. Delivery by Design will have the option
                    of repairing or replacing the items whichever is less under
                    this option.
                </p>
                <p><strong>Option 2</strong></p>
                <p>
                    Delivery Valuation Coverage is 3% of the declared value with
                    a $1000 deductible; you must opt for or decline valuation
                    coverage before items are delivered. If additional valuation
                    is not opted for prior to delivery then all items will
                    default to option one. It will be the client's
                    responsibility to ask for additional valuation and to
                    provide DBD with proof of value. Storage valuation is 2% of
                    the declared value monthly with a $1000.00 deductible.
                </p>
                <el-divider content-position="left">Storage</el-divider>
                <p>
                    The first 7 days of storage are free. Items received that
                    are not side marked appropriately or that we are unable to
                    identify will accrue storage after the free 7 days. Storage
                    is $1.40 per cubic foot per month based on the footprint of
                    each piece with a $35.00 monthly minimum.
                </p>
                <el-divider content-position="left">Sit Test</el-divider>
                <p>
                    Clients needing to come in and view items at our warehouse:
                    $50.00 plus restocking fees of $30.00 per small item and
                    $50.00 per large item for us to unpack and repack.
                </p>
                <el-divider content-position="left"
                    >High Value Items</el-divider
                >
                <p>
                    Items with a value of $10,000.00 or more will be charged an
                    additional delivery fee of 1% of the value of the item
                    unless additional valuation coverage (option 2) is selected.
                    If additional valuation coverage is not selected option one
                    will be the default for additional coverage.
                </p>
                <el-divider content-position="left"
                    >Billing and Payment</el-divider
                >
                <p>
                    All payments are due at the time of delivery unless you have
                    an account with us or other arrangements have been made
                    prior to the delivery. Larger projects may require a deposit
                    prior to delivery. Invoices on account are net 15; overdue
                    invoices will be charged 1.5% interest per month on the
                    unpaid balance. Client agrees that Delivery by Design, its
                    agencies and officers shall be entitled to collect from
                    obligor all expenses incurred in recovery of any debt or in
                    pursuing any other remedy provided by law, including but not
                    limited to reasonable attorney fees and or collection costs.
                    If we agree to bill you, all invoices are due within 15 days
                    of the delivery date. If you disagree with an invoice, it
                    must be disputed within 15 days of the delivery; Invoices
                    over 15 days old will not be adjustable.
                </p>
                <p>
                    Invoices will be sent to DBD customers only, DBD will not
                    bill your customer or any third party. DBD customers will be
                    responsible for the collection of invoices and will pay DBD
                    for such invoices. In the event that DBD makes an exception,
                    the invoice will be held under the DBD customers account and
                    that DBD customer will be responsible for payment if the
                    third party does not pay.
                </p>
                <p>
                    Any claim for loss or damage will not be accepted unless
                    noted on the delivery ticket. Labor chargeback's will not be
                    accepted, replacement or repair chargeback deductions must
                    be authorized in advance, without prior approval in writing,
                    deductions from invoices will not be accepted. All claims
                    shall be in writing and shall be accompanied by the original
                    paid invoice.
                </p>
                <el-divider content-position="left"
                    >Damage Waiver and Difficult Deliveries</el-divider
                >
                <p>
                    It is the customer's responsibility to make sure there is a
                    free and clear delivery path and that all items being
                    delivered will fit through doorways, up or down the stairs
                    or through hallways and into the specified room. If the item
                    will not fit into the room requested, our delivery crew will
                    make note of that and will leave the item in the first
                    available dry space. If it is requested that we attempt to
                    get the item into the room where our delivery crew has
                    determined that it will not fit, our delivery crew will ask
                    that you fill out a damage waiver. This waiver will release
                    Delivery by Design of all liability for damage to the items
                    being delivered and or the home or business. Damage claims
                    resulting from an unclear or unsafe delivery path will not
                    be accepted. Our delivery crew will determine if it is
                    unsafe to deliver and will then place items in the first dry
                    space that is safe to deliver to.
                </p>
                <el-divider />
                <p>
                    By shipping to Delivery by Design and or requesting a
                    delivery, you, your employees or any agents that you may
                    appoint agree to be bound by this agreement, our terms and
                    conditions and acknowledge that you have read the entire
                    agreement. Our delivery crew will make every attempt to have
                    the appointed contact sign for the items being delivered. If
                    the delivery contact is not available, they will have
                    someone sign that may or may not be an appointed agent but
                    this will not release our customer from paying the delivery
                    charges.
                </p>
            </div>
        </card>
    </modal>
</template>

<script>
import { Modal } from "src/components/UI";
import { Divider } from "element-ui";

export default {
    name: "TermsAndConditionsModal",
    components: {
        Modal,
        [Divider.name]: Divider,
    },
    props: {
        show: {
            type: Boolean,
            required: true,
        },
    },
};
</script>

<style module>
.termsModal {
    z-index: 1100;
}

.termsModalDialog {
    max-width: 800px;
    min-width: 650px;
}

.header {
    text-align: center;
}

.body {
    width: 650px;
}

.cardBody {
    display: flex;
    justify-content: center;
}

.dottedListContainer {
    display: flex;
    justify-content: center;
}

.dottedList {
    width: 100%;
}

.dottedItem:first-child {
    margin-top: 10px;
}

.dottedItem:last-child {
    margin-bottom: 10px;
}

.dottedItem {
    display: block;
    position: relative;
    height: 5px;
    margin: 22px 0;
    border-bottom: 2px dotted darkgray;
}

.dottedItem > * {
    position: absolute;
    background-color: #fff;
    transform: translateY(-50%);
}

.dottedItem > :first-child {
    left: 0px;
    padding-right: 2px;
}

.dottedItem > :last-child {
    right: 0px;
    padding-left: 2px;
}

@media (max-width: 767px) {
    .cardBody {
        padding: 15px 5px !important;
    }

    .dottedItem {
        border-bottom: none;
        margin: 4px 0;
        height: unset;
    }

    .dottedItem > * {
        position: relative;
        transform: unset;
        background: unset;
    }

    .dottedItem > :first-child {
        display: block;
        font-weight: bold;
    }
}
</style>
<style>
.el-divider__text {
    font-size: 18px;
}
</style>
